/* global google */
<template>
	<div>
		<PageHeader
			:data="{
				name: 'Map Polygons',
				breadcrumbs: [{ name: 'Home', to: '/' }],
			}"
		/>
		<router-link class="btn btn-primary mb-2" :to="'/municipalities'">
			🏙️ Municipalities
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/contacts'">
			📙 Municipalities Contacts
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/municipality-map'">
			📍 Map
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/municipalities-missing'">
			Municipalities Missing
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2 active" :to="'/municipality-map/polygons'">
			📐 Map Polygons
		</router-link>
		<div class="mb-3 mt-3">
			<h2>Draw a polygon for Map</h2>
			<div class="card">
				<div class="card-body">
					<div class="row">
						<div class="col-md-9">
							<div id="map" ref="map"></div>
						</div>
						<div class="col-md-3">
							<h3 class="d-flex justify-content-between align-items-center pb-0 mb-0">
								Polygon Coordinates <button @click="clearPolygon()" class="btn btn-danger btn-sm">Clear</button>
							</h3>
							<div class="wrapper" v-if="newPolygon.polygon.length > 2">
								<div class="polygon-data">
									{{ newPolygon.polygon }}
								</div>
								<div class="form-group">
									<label for="">Name</label>
									<input type="text" class="form-control" v-model="newPolygon.name" placeholder="Enter name" />
								</div>
								<div class="form-group">
									<label for="">Description</label>
									<textarea class="form-control" v-model="newPolygon.description" placeholder="Enter description" />
								</div>
								<button @click="savePolygon()" class="btn btn-primary mt-3">Save Polygon</button>
								<button @click="clearPolygon()" class="btn btn-danger mt-3 ms-2">Clear Polygon</button>
							</div>

							<p v-else>
								No polygon drawn yet.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="my-3">
			<div class="card mb-3">
				<div class="card-body">
					<h5 class="card-title">Polygons List</h5>
					<div v-for="polygon in polygons" :key="polygon.id" class="border-bottom py-2 d-flex justify-content-between align-items-center">
						<div>
							<strong>{{ polygon.name }}</strong
							><br />
							<small class="text-muted">{{ polygon.description }}</small>
						</div>
						<div>
							<button class="btn btn-sm btn-outline-primary me-2" @click="showPolygon(polygon.polygon)">
								Show
							</button>
							<button class="btn btn-sm btn-outline-danger" @click="deletePolygon(polygon.id)">
								Delete
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import restApi from '../../api/index.js'
export default {
	name: 'PolygonMap',
	components: {
		PageHeader,
	},
	data() {
		return {
			map: null,
			drawingManager: null,
			selectedShape: null,
			isGoogleMapsLoaded: false,
			newPolygon: {
				name: '',
				description: '',
				polygon: [],
			},
			polygons: [],
		}
	},
	mounted() {
		this.loadGoogleMaps()
		this.getAllPolygons()
	},
	methods: {
		getAllPolygons() {
			restApi
				.get('/map-polygons')
				.then(({ data }) => {
					this.polygons = data
					this.loading = false
				})
				.catch(error => {
					console.log(error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error fetching municipalities in radius data',
						timer: 6000,
					})
					this.loading = false
				})
		},

		getPolygonPath(polygonId) {
			restApi
				.get('/map-polygons/' + polygonId)
				.then(({ data }) => {
					this.showPolygon(JSON.parse(data.polygon))
				})
				.catch(error => {
					console.log(error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error fetching polygon data',
						timer: 6000,
					})
				})
		},

		loadGoogleMaps() {
			// Check if Google Maps is already loaded
			if (window.google && window.google.maps) {
				this.initMap()
				return
			}

			// Check if we're already loading the script
			if (document.querySelector('script[src*="maps.googleapis.com"]')) {
				// If script is loading but not ready, wait for it
				this.waitForGoogleMaps()
				return
			}

			// Load the Google Maps script
			const script = document.createElement('script')
			script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBz8J6lBTaZOiNhHDTX9BB742f2NNKf4wk&libraries=drawing`
			script.async = true
			script.defer = true
			script.onload = () => {
				this.isGoogleMapsLoaded = true
				this.initMap()
			}
			document.head.appendChild(script)
		},

		waitForGoogleMaps() {
			const checkInterval = setInterval(() => {
				if (window.google && window.google.maps) {
					clearInterval(checkInterval)
					this.initMap()
				}
			}, 100)
		},

		initMap() {
			/* eslint-disable no-undef */
			if (!window.google || !window.google.maps) {
				console.error('Google Maps API not loaded yet')
				return
			}

			this.map = new google.maps.Map(this.$refs.map, {
				center: { lat: 44.8228, lng: -87.366 },
				zoom: 4,
			})

			this.drawingManager = new google.maps.drawing.DrawingManager({
				drawingMode: google.maps.drawing.OverlayType.POLYGON,
				drawingControl: true,
				drawingControlOptions: {
					position: google.maps.ControlPosition.TOP_CENTER,
					drawingModes: ['polygon'],
				},
				polygonOptions: {
					editable: true,
				},
			})

			this.drawingManager.setMap(this.map)

			google.maps.event.addListener(this.drawingManager, 'overlaycomplete', event => {
				if (event.type === google.maps.drawing.OverlayType.POLYGON) {
					if (this.selectedShape) {
						this.selectedShape.setMap(null)
					}
					this.selectedShape = event.overlay

					const path = this.selectedShape.getPath()
					const coordinates = []

					for (let i = 0; i < path.getLength(); i++) {
						const latLng = path.getAt(i)
						coordinates.push({ lat: latLng.lat(), lng: latLng.lng() })
					}
					this.newPolygon.polygon = coordinates
				}
			})
			/* eslint-enable no-undef */
		},

		clearPolygon() {
			if (this.selectedShape) {
				this.selectedShape.setMap(null)
				this.selectedShape = null
				this.newPolygon.polygon = []
			}
		},

		getPrecisePolygonCenter(paths) {
			let area = 0
			let lat = 0
			let lng = 0
			const points = [...paths, paths[0]] // zatvori poligon

			for (let i = 0; i < points.length - 1; i++) {
				const xi = points[i].lng
				const yi = points[i].lat
				const xi1 = points[i + 1].lng
				const yi1 = points[i + 1].lat

				const a = xi * yi1 - xi1 * yi
				area += a
				lng += (xi + xi1) * a
				lat += (yi + yi1) * a
			}

			area *= 0.5
			const factor = 1 / (6 * area)
			return {
				lat: lat * factor,
				lng: lng * factor,
			}
		},

		showPolygon(coordinates) {
			coordinates = JSON.parse(coordinates)

			let newCenter = this.getPrecisePolygonCenter(coordinates)

			// Očisti prethodni poligon ako postoji
			if (this.selectedShape) {
				this.selectedShape.setMap(null)
				this.selectedShape = null
			}

			/* eslint-disable no-undef */
			const polygon = new google.maps.Polygon({
				paths: coordinates,
				editable: true,
				strokeColor: '#FF0000',
				strokeOpacity: 0.8,
				strokeWeight: 2,
				fillColor: '#FF0000',
				fillOpacity: 0.35,
				map: this.map,
			})
			/* eslint-enable no-undef */

			this.selectedShape = polygon

			// Centriraj mapu na prvi ugao poligona
			if (coordinates.length) {
				this.map.setCenter(newCenter)
				this.map.setZoom(7)
			}
		},

		savePolygon() {
			if (this.newPolygon.polygon.length < 3) {
				alert('Please draw a polygon with at least 3 points')
				return
			}

			this.newPolygon.polygon = JSON.stringify(this.newPolygon.polygon)
			restApi
				.post('/map-polygons', this.newPolygon)
				.then(() => {
					this.$swal.fire({
						icon: 'success',
						title: 'Polygon saved successfully',
						timer: 6000,
					})
					this.newPolygon = {
						name: '',
						description: '',
						polygon: [],
					}
					this.clearPolygon()
				})
				.catch(error => {
					console.log(error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error saving polygon',
						timer: 6000,
					})
				})
		},

		deletePolygon(id) {
			restApi.delete(`/map-polygons/${id}`).then(() => this.getAllPolygons())
		},
	},
}
</script>

<style scoped>
#map {
	height: 500px;
	width: 100%;
}
.polygon-data {
	height: 200px;
	overflow: auto;
	border: 1px solid #ddd;
	padding: 5px;
	font-size: 10px;
	border-radius: 10px;
	scrollbar-width: none; /* Firefox */
	-ms-overflow-style: none; /* Internet Explorer 10+ */
}
</style>
